import { render } from "./GeneralSliders.vue?vue&type=template&id=977ecfc0"
import script from "./GeneralSliders.vue?vue&type=script&lang=js"
export * from "./GeneralSliders.vue?vue&type=script&lang=js"

import "./GeneralSliders.vue?vue&type=style&index=0&id=977ecfc0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__